module.exports = __webpack_public_path__ + "static/flags/TN-d897294017e1050b838189d7ad50c4ab.gif";